/**
 * Checks if a value is null or undefined.
 *
 * @param val - The value to check.
 * @returns A boolean indicating whether the value is null or undefined.
 */

export function isNil(val: unknown): val is null | undefined {
  return isNull(val) || isUndefined(val)
}
